<div
  class="add-network-container full-width full-height flex column p-16 gap-16"
>
  <kc-dropdown-select
    [options]="presetOptions"
    [placeholder]="'Load a well-known network'"
    [isFullWidth]="true"
    [isSearchable]="true"
    [value]="selectedPresetChainId()"
    (valueChange)="onPresetSelected($any($event))"
  >
    <ng-template #prefixTemplate>
      @if (
        selectedPresetChainId() &&
        getPresetNetworkIcon(selectedPresetChainId()!)
      ) {
        <img
          [src]="getPresetNetworkIcon(selectedPresetChainId()!)!"
          alt=""
          class="preset-trigger-icon"
        />
      }
    </ng-template>

    <ng-template #optionTemplate let-option>
      <div class="preset-option">
        @if (getPresetNetworkIcon(option.value)) {
          <img
            [src]="getPresetNetworkIcon(option.value)!"
            alt=""
            class="preset-option-icon"
          />
        } @else {
          <div class="preset-option-fallback">{{ option.label.charAt(0) }}</div>
        }
        <span>{{ option.label }}</span>
      </div>
    </ng-template>
  </kc-dropdown-select>

  <div class="fields-section flex column gap-12">
    <kc-input
      [infoLabel]="{ label: 'Network Name' }"
      [placeholder]="'e.g. Base, Polygon, Arbitrum'"
      [type]="'text'"
      [ngModel]="networkName()"
      (valueChange)="networkName.set($any($event) || '')"
    />

    <kc-number-input
      [infoLabel]="{ label: 'Chain ID' }"
      [placeholder]="'e.g. 8453'"
      [enforceEthersFormat]="false"
      [isValid]="!chainIdError()"
      [ngModel]="chainId()"
      (valueChange)="chainId.set(coerceToString($event))"
    />
    @if (chainIdError()) {
      <span class="kc-input-error-text">{{ chainIdError() }}</span>
    }

    <kc-input
      [infoLabel]="{ label: 'RPC URL' }"
      [placeholder]="'https://rpc.example.com'"
      [type]="'text'"
      [isValid]="!rpcUrlError()"
      [ngModel]="rpcUrl()"
      (valueChange)="rpcUrl.set($any($event) || '')"
    />
    @if (rpcUrlError()) {
      <span class="kc-input-error-text">{{ rpcUrlError() }}</span>
    }

    <kc-input
      [infoLabel]="{ label: 'Currency Symbol' }"
      [placeholder]="'ETH'"
      [type]="'text'"
      [ngModel]="currencySymbol()"
      (valueChange)="currencySymbol.set($any($event) || '')"
    />

    <kc-number-input
      [infoLabel]="{ label: 'Decimals' }"
      [placeholder]="'18'"
      [enforceEthersFormat]="false"
      [isValid]="!decimalsError()"
      [ngModel]="currencyDecimals()"
      (valueChange)="currencyDecimals.set(coerceToString($event))"
    />
    @if (decimalsError()) {
      <span class="kc-input-error-text">{{ decimalsError() }}</span>
    }

    <kc-input
      [infoLabel]="{ label: 'Block Explorer URL (optional)' }"
      [placeholder]="'https://explorer.example.com'"
      [type]="'text'"
      [isValid]="!explorerUrlError()"
      [ngModel]="explorerUrl()"
      (valueChange)="explorerUrl.set($any($event) || '')"
    />
    @if (explorerUrlError()) {
      <span class="kc-input-error-text">{{ explorerUrlError() }}</span>
    }
  </div>

  <div class="action-buttons flex gap-12 mt-auto">
    <kc-button
      [variant]="'secondary'"
      [size]="'m'"
      [text]="'Cancel'"
      [isFullWidth]="true"
      class="flex-1"
      (buttonClick)="onCancel()"
    />
    <kc-button
      [variant]="'primary'"
      [size]="'m'"
      [text]="isSaving() ? 'Adding...' : 'Add Network'"
      [isDisabled]="isSaving()"
      [isFullWidth]="true"
      class="flex-1 add-network-btn"
      (buttonClick)="onSave()"
    />
  </div>
</div>
